import {Component, inject, Inject} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef
} from "@angular/material/dialog";
import {Match} from "../../model/match";
import {MatButton} from "@angular/material/button";
import {TournamentPlayer} from "../../model/tournamentPlayer";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatOption, MatSelect} from "@angular/material/select";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-court-selection',
  imports: [
    MatDialogContent,
    MatButton,
    MatDialogClose,
    MatDialogActions,
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    FormsModule,

  ],
  templateUrl: './court-selection.component.html',
  standalone: true,
  styleUrl: './court-selection.component.scss'
})
export class CourtSelectionComponent {

  court: number;
  counter: TournamentPlayer;

  readonly dialogRef = inject(MatDialogRef<CourtSelectionComponent>);

  constructor(@Inject(MAT_DIALOG_DATA) public data: {
    match: Match,
    availableCourts: number[],
    totalCourts: number,
    availableCounters: TournamentPlayer[]
  }) {}

  onAnnulerenClick() {
    this.dialogRef.close();
  }

  selectCourt(selectedCourt: number) {
    this.court = selectedCourt;
  }
}
